import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from '../newConversation.translations'

import { useShoppingAssistantHost } from './useShoppingAssistantHost'
import type { NewChatDialog } from './useShoppingAssistantHost.injection-key'

function buildDialog(
  i18n: ReturnType<typeof useI18n>,
  acceptButtonText: string,
  onAccept: () => void,
): NewChatDialog {
  return {
    title: i18n(translations.title),
    description: i18n(translations.description),
    acceptButtonText,
    declineButtonText: i18n(translations.declineButtonText),
    onAccept,
  }
}

/**
 * Shared dialog-confirmation logic for the "start a new conversation" CTA.
 *
 * `useNewConversationDialog` calls `useShoppingAssistantHost()` and is meant
 * for components that inject the host (Header, ChatHistoryModal,
 * ShoppingAssistantChat). Host adapter composables build the dialog
 * themselves (see WebSidebarShoppingAssistantHost's seeded-launch dialog) —
 * they are creating the host, so injecting it would be circular.
 */
export function useNewConversationDialog() {
  const i18n = useI18n()
  const { newChat } = useShoppingAssistantHost()

  function requestNewChat(onAccept: () => void) {
    newChat(buildDialog(i18n, i18n(translations.acceptButtonText), onAccept))
  }

  return { requestNewChat }
}
